import React from "react";
import { useSearchParams } from "react-router-dom";
import { useAgentsStore } from "../../../../../../../../../../store/agents.store";
import { selectAgentHierarchy } from "../../../../../../../../../../store/agentDetail/agentDetailSelectors";
import styles from "./agentHierarchyRow.module.css";
import { EDIT_AGENT_QUERY_PARAM } from "../../../../../../../../../../agents.constants";
import { AgentHierarchyRow } from "./components/agentHierarchyRow/agentHierarchyRow.index";

export const AgentHierarchyTree = () => {
    const hierarchyInfo = useAgentsStore(selectAgentHierarchy);
    const [searchParams] = useSearchParams();
    const currentUserId = Number(searchParams.get(EDIT_AGENT_QUERY_PARAM));

    if (!hierarchyInfo || hierarchyInfo.length === 0) {
        return <p className={styles.noData}>No hierarchy information available</p>;
    }

    return (
        <div className={styles.treeContainer}>
            {hierarchyInfo.map((node) => (
                <AgentHierarchyRow
                    key={node.userId}
                    node={node}
                    currentUserId={currentUserId}
                    isRoot
                />
            ))}
        </div>
    );
};
